import Image from 'next/legacy/image'
import styled from 'styled-components'
import Container from 'src/styles/Container'
import { H3 } from 'src/styles/Typography'
import humanaLogo from 'src/components/icons/insurersParade/humana-logo.svg'
import aetnaLogo from 'src/components/icons/insurersParade/aetna-logo.svg'
import cignaLogo from 'src/components/icons/insurersParade/cigna-logo.svg'
import bcLogo from 'src/components/icons/insurersParade/bc-logo.svg'
import uhcLogo from 'src/components/icons/insurersParade/uhc-logo.svg'
import omahaLogo from 'src/components/icons/insurersParade/omaha-logo-new-horizontal.svg'

export default function CareersInsurersParade({ borderTopSlug = false, vertical }) {
  return (
    <HomeInsurersParadeWrapper borderTopSlug={borderTopSlug} vertical={vertical}>
      <Container>
        <HomeInsurersParadeInner>
          <div>
            <H3>
              Work <span className="hide-desktop">with top</span>
              <span className="hide-mobile">with top</span> insurers nationwide
            </H3>
          </div>
          <Right>
            <Image objectFit="contain" src={humanaLogo} alt="Humana" />
            <Image objectFit="contain" src={aetnaLogo} alt="Aetna" />
            <Image objectFit="contain" src={cignaLogo} alt="Cigna" />
            <Image objectFit="contain" src={bcLogo} alt="BlueCross BlueShield" />
            <Image objectFit="contain" src={uhcLogo} alt="UnitedHealthcare" />
            <Image objectFit="contain" src={omahaLogo} alt="Mutual of Ohmaha" />
          </Right>
        </HomeInsurersParadeInner>
      </Container>
    </HomeInsurersParadeWrapper>
  )
}

const HomeInsurersParadeWrapper = styled.div`
  padding: 3rem 0;
  background: ${({ theme, vertical }) => theme.colors[vertical].DEFAULT};
  border-top: ${({ borderTopSlug, theme }) =>
    borderTopSlug ? `6px solid ${theme.colors[borderTopSlug].DEFAULT}` : 'none'};

  ${H3} {
    color: white;
    margin: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 3rem 0 56px;
  }
`

const Right = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 104px);
  grid-gap: 39px;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    grid-template-columns: repeat(2, 128px);
  }
`

const HomeInsurersParadeInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    flex-direction: column;
    align-items: center;
    gap: 40px;
    text-align: center;
  }
`
